<template>
  <div class="list" @click.stop="show">
    <div class="list-header">
      <h2>请选择您与对方的订单<span>（最多三个）</span></h2>
      <div class="close-icon" @click="closeToast">
        <Icon name="cross" />
      </div>
    </div>
    <div class="list-tab">
      <div class="list-tab-item" :class="{ active: tabType == '2' }" @click="tabClick('2')">
        我买到的
      </div>
      <div class="list-tab-item" :class="{ active: tabType == '1' }" @click="tabClick('1')">
        我卖出的
      </div>
    </div>
    <Skeleton title :row="3" :loading="loading" v-if="boughtList.length != 0 || soldList.length != 0">
      <div class="list-wrap">
        <order-list
          v-show="tabType == '2'"
          :list="boughtList"
          @select="select"
          :curSelect="currentSelected"
          @to-bottom="fetchMoreBought"
        ></order-list>
        <order-list
          v-show="tabType == '1'"
          :list="soldList"
          @select="select"
          :curSelect="currentSelected"
          @to-bottom="fetchMoreSold"
        ></order-list>
      </div>
    </Skeleton>
    <Stance
      type="general"
      :show-info="false"
      descText="没有买过对方的商品欧~"
      v-if="boughtList.length === 0 && !loading && tabType == '2'"
    />
    <Stance
      type="general"
      :show-info="false"
      descText="对方没有买过商品欧~"
      v-if="soldList.length === 0 && !loading && tabType == '1'"
    />
     <z-button size="large" type="primary" :disabled="currentSelected.length === 0" @click="commit">{{btnText}}</z-button>
  </div>
</template>

<script>
import { Icon, Skeleton, Stance, Button } from '@zz-common/zz-ui'
import { getorderlist } from '@api/resourceApi'
import OrderList from './OrderList'
import { toast } from '../../../native'
// import { getCookie } from '../../../lib/utils'

// const DEFAULT_PAGE_SIZE = 10
const MAX_CHOICE_COUNT = 3 //最大多选数
export default {
  name: 'ReportOrderList',
  props: ['beReportedUid'],
  data() {
    return {
      tabType: '2', // 当前tab激活列表，2为买到的、1为卖出的
      currentSelected: [],
      soldList: [],
      boughtList: [],
      fetchSoldLoading: false,
      fetchBoughtLoading: false,
      isSoldListEnd: false,
      isBoughtListEnd: false,
      curSoldPageNo: 1,
      curBoughtPageNo: 1,
      firstDisaplay: true,
      loading: true
    }
  },
  computed: {
    btnText() {
      if (this.currentSelected.length > 0) return '下一步'
      return '请选择要举报的订单'
    }
  },
  mounted() {
    if (this.defaultSelect) this.currentSelected.push(this.defaultSelect)
    this.init()
  },
  methods: {
    show() {
      console.log('点击内部遮罩层不关闭')
    },
    tabClick(type) {
      if (type === this.tabType) return
      //this.currentSelected = [];
      this.tabType = type
      console.log('---type', this.tabType)
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.count++
      }, 500)
    },
    init() {
      this.fetchBought()
      this.fetchSold()
    },
    select(item) {
      if (this.currentSelected.indexOf(item) > -1) {
        this.currentSelected.splice(this.currentSelected.indexOf(item), 1)
        return ''
      }
      if (
        this.currentSelected.length === MAX_CHOICE_COUNT &&
          this.currentSelected.indexOf(item) === -1
      ) {
        return toast({
          msg: `您最多可以举报${MAX_CHOICE_COUNT}个订单`,
          style: '2'
        })
      }
      this.currentSelected.push(item)
    },
    commit() {
      this.$emit('selected', this.currentSelected)
    },
    fetchMore() {
      if (this.fetchLoading || this.isPageEnd) return
      this.getProductInfo().then((data) => {
        if (data && data.length <= 0) {
          this.isPageEnd = true
        }
      })
    },
    closeToast() {
      this.$emit('close')
    },
    // 获取订单接口
    getListInfo(type) {
      this.fetchLoading = true
      return getorderlist({
        type,
        toUid: this.beReportedUid,
        pageNo: type === '2' ? this.curBoughtPageNo++ : this.curSoldPageNo++
      })
        .then((res) => {
          this.loading = false
          return res
        })
        .catch((err) => {
          this.fetchLoading = false
          this.loading = false
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    fetchBought() {
      if (this.fetchBoughtLoading || this.isBoughtListEnd) return
      this.fetchBoughtLoading = true
      this.getListInfo('2').then((data = []) => {
        this.fetchBoughtLoading = false
        if (data && data.length === 0) {
          this.isBoughtListEnd = true
        }
        this.boughtList = this.boughtList.concat(data)
      })
    },
    fetchSold() {
      if (this.fetchSoldLoading || this.isSoldListEnd) return
      this.fetchSoldLoading = true
      this.getListInfo('1').then((data = []) => {
        this.fetchSoldLoading = false
        if (data && data.length === 0) {
          this.isSoldListEnd = true
        }
        this.soldList = this.soldList.concat(data)
      })
    },
    fetchMoreSold() {
      this.fetchSold()
    },
    fetchMoreBought() {
      this.fetchBought()
    }
  },
  components: {
    zButton: Button,
    OrderList,
    Icon,
    Stance,
    Skeleton
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
